export {default} from './TemplateTermsAndConditions'
